export const APP_DATE_FORMATS = {
  parse: {
    dateInput: 'dd-MM-yyyy',
    timeInput: 'HH:mm',
  },
  display: {
    dateInput: 'dd-MM-yyyy',
    monthYearLabel: 'LLLL yyyy',
    dateA11yLabel: 'DDD',
    monthYearA11yLabel: 'LLLL yyyy',
    timeInput: 'HH:mm',
    timeOptionLabel: 'HH:mm',
  },
};

export const APP_DATE_LOCALE = 'en-GB';
